import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./components/auth/auth.guard";
import { PreventLoggedInAccess } from "./components/auth/auth.prevent-loggedin-access";
import { EsqueciSenhaComponent } from "./components/auth/esqueci-senha/esqueci-senha.component";
import { LoginComponent } from "./components/auth/login/login.component";
import { PasswordResetComponent } from "./components/auth/password-reset/password-reset.component";
import { BankListComponent } from "./components/bank-list/bank-list.component";
import { BankRegisterComponent } from "./components/bank-register/bank-register.component";
import { BatchEmailComponent } from "./components/batch-email/batch-email.component";
import { CadastroUsuarioComponent } from "./components/cadastro-usuario/cadastro-usuario.component";
import { CalendarioComponent } from "./components/calendario/calendario.component";
import { CetipComponent } from "./components/cetip/cetip.component";
import { CompromissadaCompraComponent } from "./components/compromissada-compra/compromissada-compra.component";
import { CotaComponent } from "./components/cota/cota.component";
import { CounterpartListComponent } from "./components/counterpart-list/counterpart-list.component";
import { CounterpartRegisterComponent } from "./components/counterpart-register/counterpart-register.component";
import { CutoffCreateComponent } from "./components/cutoff/cutoff-create/cutoff-create.component";
import { CutoffDefaultUpdateComponent } from "./components/cutoff/cutoff-default-update/cutoff-default-update.component";
import { CutoffExceptionHistoryComponent } from "./components/cutoff/cutoff-exception-history/cutoff-exception-history.component";
import { CutoffComponent } from "./components/cutoff/cutoff.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ExchangeComponent } from "./components/exchange/exchange.component";
import { ExpensesComponent } from "./components/expenses/expenses.component";
import { FuturosComponent } from "./components/futuros/futuros.component";
import { CadastroGrupoComponent } from "./components/grupos/cadastro.component";
import { GruposComponent } from "./components/grupos/grupos.component";
import { HomeComponent } from "./components/home/home.component";
import { ExpandableExampleComponent } from "./components/infrastructure/expandable-example/expandable-example";
import { LiabilitiesComponent } from "./components/liabilities/liabilities.component";
import { LoanComponent } from "./components/loan/loan.component";
import { MargemComponent } from "./components/margem/margem.component";
import { MonitorGeralComponent } from "./components/monitor-geral/monitor-geral.component";
import { MonitorArquivosComponent } from "./components/monitor-recebiveis/monitor-arquivos.component";
import { MonitorRecebiveisComponent } from "./components/monitor-recebiveis/monitor-recebiveis.component";
import { MonitoresComponent } from "./components/monitores/monitores.component";
import { ObterCargasComponent } from "./components/obter-cargas/obter-cargas.component";
import { OperationStructuredComponent } from "./components/operation-structured/operation-structured.component";
import { OrdemOperacaoEstruturadaComponent } from "./components/ordem-operacao-estruturada/ordem-operacao-estruturada.component";
import { OutstandingMonitorComponent } from "./components/outstanding-monitor/outstanding-monitor.component";
import { ReleasesComponent } from "./components/releases/releases.component";
import { BoletaRendaVariavelComponent } from "./components/renda-variavel/renda-variavel.component";
import { ReportUploadComponent } from "./components/report-upload/report-upload.component";
import { RendaVariavelComponent } from "./components/rv/rv.component";
import { SelicComponent } from "./components/selic/selic.component";
import { SwapCetipComponent } from "./components/swap-cetip/swap-cetip.component";
import { TermoMoedaComponent } from "./components/termo-moeda/termo-moeda.component";
import { TransferComponent } from "./components/transfer/transfer.component";
import { UploadCargaComponent } from "./components/upload-carga/upload-carga.component";
import { UploadRvComponent } from "./components/upload-rv/upload-rv.component";
import { UploadTicketComponent } from "./components/upload-ticket/upload-ticket.component";
import { UploadTransferOrdeComponent } from "./components/upload-to/upload-to.component";
import { UsuariosComponent } from "./components/usuarios/usuarios.component";
import { WalletComponent } from "./components/wallet/wallet.component";

const appRoutes: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        canActivateChild: [AuthGuard],
        children: [
          {
            path: "quota",
            component: CotaComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "quota/:id",
            component: CotaComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "cetip",
            component: CetipComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "cetip/:id",
            component: CetipComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "selic",
            component: SelicComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "selic/:id",
            component: SelicComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "contracted",
            component: CompromissadaCompraComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "contracted/:id",
            component: CompromissadaCompraComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "futures",
            component: FuturosComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "futures/:id",
            component: FuturosComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "swap-cetip",
            component: SwapCetipComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "swap-cetip/:id",
            component: SwapCetipComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "margin",
            component: MargemComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "margin/:id",
            component: MargemComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "currency-term",
            component: TermoMoedaComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "currency-term/:id",
            component: TermoMoedaComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "rv",
            component: RendaVariavelComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "rv/:id",
            component: RendaVariavelComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "transfer",
            component: TransferComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "transfer/:id",
            component: TransferComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          { path: "status", component: MonitorGeralComponent },
          { path: "todos", component: MonitoresComponent },
          {
            path: "painel-pendencia-atuacao",
            component: OutstandingMonitorComponent,
          },
          { path: "usuarios", component: UsuariosComponent },
          { path: "counterpart", component: CounterpartListComponent },
          {
            path: "cadastro-contraparte",
            component: CounterpartRegisterComponent,
          },
          {
            path: "cadastro-contraparte/:id",
            component: CounterpartRegisterComponent,
          },
          { path: "cadastro-usuario", component: CadastroUsuarioComponent },
          { path: "cadastro-usuario/:id", component: CadastroUsuarioComponent },
          { path: "grupos", component: GruposComponent },
          { path: "grupos/:id", component: GruposComponent },
          { path: "grupos-cadastro", component: CadastroGrupoComponent },
          { path: "grupos-cadastro/:id", component: CadastroGrupoComponent },
          { path: "uploads/pesc", component: UploadRvComponent },
          { path: "uploads/ticket", component: UploadTicketComponent },
          { path: "uploads/carga", component: UploadCargaComponent },
          { path: "uploads/to", component: UploadTransferOrdeComponent },
          { path: "monitor-recebiveis", component: MonitorRecebiveisComponent },
          { path: "monitor-arquivos", component: MonitorArquivosComponent },
          { path: "exchange", component: ExchangeComponent },
          { path: "exchange/:id", component: ExchangeComponent },
          { path: "cutoff", component: CutoffComponent },
          {
            path: "cutoff/cutoff-default-update",
            component: CutoffDefaultUpdateComponent,
          },
          {
            path: "cutoff/cutoff-default-update/:id",
            component: CutoffDefaultUpdateComponent,
          },
          { path: "cutoff/cutoff-create", component: CutoffCreateComponent },
          {
            path: "cutoff/cutoff-create/:id",
            component: CutoffCreateComponent,
          },
          {
            path: "cutoff/history",
            component: CutoffExceptionHistoryComponent,
          },
          { path: "loan", component: LoanComponent },
          {
            path: "loan/:id",
            component: LoanComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          { path: "renda-variavel", component: BoletaRendaVariavelComponent },
          { path: "releases", component: ReleasesComponent },
          { path: "relatorios", component: DashboardComponent },
          {
            path: "expenses",
            component: ExpensesComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "expenses/:id",
            component: ExpensesComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "liabilities",
            component: LiabilitiesComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "liabilities/:id",
            component: LiabilitiesComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "structured-order",
            component: OrdemOperacaoEstruturadaComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          {
            path: "structured-order/:id",
            component: OrdemOperacaoEstruturadaComponent,
            runGuardsAndResolvers: "paramsChange",
          },
          { path: "calendario", component: CalendarioComponent },
          { path: "structured", component: OperationStructuredComponent },
          { path: "structured/:id", component: OperationStructuredComponent },
          { path: "obter-cargas", component: ObterCargasComponent },
          { path: "wallet", component: WalletComponent },
          { path: "relatorio-upload", component: ReportUploadComponent },
          { path: "batch-email", component: BatchEmailComponent },
          { path: "bank-list", component: BankListComponent },
          { path: "bank-register", component: BankRegisterComponent },
          { path: "bank-register/:id", component: BankRegisterComponent },
        ],
      },
    ],
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [PreventLoggedInAccess],
  },
  {
    path: "test",
    component: ExpandableExampleComponent,
    canActivate: [PreventLoggedInAccess],
  },
  {
    path: "password-reset/:login",
    component: PasswordResetComponent,
    canActivate: [PreventLoggedInAccess],
  },
  {
    path: "password-reset/:login/:resetHash",
    component: PasswordResetComponent,
    canActivate: [PreventLoggedInAccess],
  },
  {
    path: "esqueci-senha",
    component: EsqueciSenhaComponent,
    canActivate: [PreventLoggedInAccess],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false,
      scrollPositionRestoration: "enabled",
      onSameUrlNavigation: "reload",
      relativeLinkResolution: "legacy",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
